export const dbConfs = {
    caches: {
        deletable: true,
        failTime: 0,
    },
    catalog_dexie: {
        deletable: true,
        failTime: 0,
    },
    contact_dexie: {
        deletable: false,
        failTime: 0,
    },
    fileop: {
        deletable: false,
        failTime: 0,
    },
    mail_new: {
        deletable: false,
        failTime: 0,
    },
    operation: {
        deletable: false,
        failTime: 0,
    },
    task_global: {
        deletable: false,
        failTime: 0,
    },
    task_mail: {
        deletable: false,
        failTime: 0,
    },
};
